/* eslint-disable react-native/no-inline-styles,react-native/no-raw-text */
import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { convertToHtmlTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/texts.common';
import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import { Html } from '@react-three/drei';
import { observer } from 'mobx-react-lite';

export type RoundedButtonProps = {
  textProps: CardTextProps;
  size: PlaneSize;
  borderColor?: string;
  borderWidth?: number;
  backgroundColor?: string;
  radius?: number;
  onClick?: () => void;
  debounce?: number; // in ms
};

export const RoundedButton = observer(function RoundedButton({
  textProps,
  size,
  borderColor = 'black',
  borderWidth = 0,
  backgroundColor = 'white',
  radius = 0,
  onClick,
}: RoundedButtonProps) {
  const props = convertToHtmlTextProps(textProps);

  return (
    <Html
      style={{
        width: size.width,
        height: size.height,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
      center
      zIndexRange={[0, 0]}
    >
      <button
        onClick={onClick}
        style={{
          backgroundColor,
          width: '100%',
          height: '100%',
          borderRadius: radius,
          borderWidth,
          borderColor,
          borderStyle: 'solid',
          fontSize: props.fontSize,
          fontFamily: props.fontAsset,
          letterSpacing: props.letterSpacing,
          cursor: 'pointer',
        }}
      >
        Find out more
      </button>
    </Html>
  );
});
